import { useEffect, useState } from "react"

const useScrollPosition = (offset = 0) => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const wrapper = document.querySelector("#gatsby-focus-wrapper")
    if (!wrapper) return undefined // ✅ линтер доволен

    const handleScroll = () => {
      const scrollTop = wrapper.scrollTop
      setIsScrolled(scrollTop > offset)
    }

    wrapper.addEventListener("scroll", handleScroll, { passive: true })
    handleScroll()

    return () => {
      wrapper.removeEventListener("scroll", handleScroll)
    }
  }, [offset])

  return isScrolled
}

export default useScrollPosition
